export const KUBRA_TERMS_OF_USE_URL = 'https://www.kubra.com/terms-of-use';
export const KUBRA_PRIVACY_POLICY_URL = 'https://www.kubra.com/privacy-policy';